import { render, staticRenderFns } from "./MoneyInputConfig.vue?vue&type=template&id=3e9a1e32&scoped=true"
import script from "./MoneyInputConfig.vue?vue&type=script&lang=js"
export * from "./MoneyInputConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9a1e32",
  null
  
)

export default component.exports